import ScrollReveal from "scrollreveal";
export const sr = ScrollReveal({
    origin: "top",
    distance: "40px",
    duration: 2000,
    reset: true,
  });

